import {
    Component,
    OnInit,
    Input,
    ViewChild,
    ElementRef,
    ViewEncapsulation,
    Inject,
    LOCALE_ID,
} from '@angular/core';

import { FlowItem } from './flow/flow-item';
import { ModalFlowService } from './modalflow.service';
import { MainConfig } from '../../../../conf/main.config';

@Component({
    selector: 'app-modalflow',
    templateUrl: './modalflow.component.html',
    styleUrls: ['./modalflow.component.css'],
    encapsulation: ViewEncapsulation.None,
})
export class ModalFlowComponent implements OnInit {
    @Input('coords') coords;
    @Input('program_id') program_id;
    @Input('registration_required') registration_required;
    @Input('form_message') form_message;
    // @Input('default_image') default_image; TODO: à supprimer si pas utilisé
    @Input('updateData') updateData;
    @Input('modalversion') modalversion: boolean = true;
    @ViewChild('content', { static: true }) content: ElementRef;
    MainConfig = MainConfig;
    flowitems: FlowItem[];
    timeout: any;

    constructor(
        @Inject(LOCALE_ID) readonly localeId: string,
        public flowService: ModalFlowService
    ) {}

    ngOnInit() {
        this.flowService.modalversion = this.modalversion;

        if (!this.modalversion) {
            this.flowitems = this.buildFlowItems(true);
            this.flowService.display = true;
        }
    }

    private buildFlowItems(inlineMode: boolean = false): FlowItem[] {
        return this.flowService.getFlowItems({
            coords: this.coords,
            program_id: this.program_id,
            registration_required: this.registration_required,
            form_message: this.form_message,
            // default_image: this.default_image, #TODO : où est ce qu'il est utilisé ?
            updateData: this.updateData,
            inlineMode: inlineMode,
        });
    }

    clicked() {
        this.flowitems = this.buildFlowItems(false);
        if (this.modalversion) {
            this.flowService.open(this.content);
        } else {
            this.flowService.display = true;
        }
    }

    step(componentName) {}
}
